import React from "react";
import GalleryApps from "../Galleryapps/GalleryApps";
import MiniGLBViewer from "./Spaceship"; // 👈 添加这行

export default function GalleryPage() {
  return (
    <div style={{ width: "100vw", height: "100vh", overflow: "hidden" }}>
      {/* 背景 Sketchfab 3D */}
      <div className="sketchfab-fullscreen">
        <iframe
          title="Futuristic Architectural Dome Interior"
          frameBorder="0"
          allowFullScreen
          mozallowfullscreen="true"
          webkitallowfullscreen="true"
          allow="autoplay; fullscreen; xr-spatial-tracking"
          src="https://sketchfab.com/models/4a9547141fb04224a93f73625527eedc/embed?autostart=1&annotation=1&annotation_cycle=10&ui_infos=0&ui_watermark_link=0&ui_watermark=0"
        />
      </div>

      {/* 卡片浮动层 */}
      <div style={{ position: "relative", zIndex: 30 }}>
        <GalleryApps />
      </div>

      {/* 飞船回来了 */}
      <MiniGLBViewer url="/models/spaceship.glb" />

      {/* CSS 样式 */}
      <style>{`
        .sketchfab-fullscreen {
          position: fixed;
          top: 0; left: 0;
          width: 100vw; height: 100vh;
          z-index: 0;
          pointer-events: none;
          overflow: hidden;
        }
        .sketchfab-fullscreen > iframe {
          position: absolute;
          top: 50%; left: 50%;
          width: auto; height: auto;
          min-width: 100%;
          min-height: 100%;
             width: 120% !important;
    height: 120% !important;
          transform: translate(-50%, -50%);
          object-fit: cover;
          pointer-events: auto;
        }
      `}</style>
    </div>
  );
}
